/**
 * @generated SignedSource<<692d4d80f4b63de3fdb678bc5fccf9af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewInRoom_viewInRoomPhoto$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoomImageCredits_viewInRoomPhoto" | "ViewInRoomImage_viewInRoomPhoto">;
  readonly " $fragmentType": "ViewInRoom_viewInRoomPhoto";
};
export type ViewInRoom_viewInRoomPhoto$key = {
  readonly " $data"?: ViewInRoom_viewInRoomPhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoom_viewInRoomPhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoom_viewInRoomPhoto",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImage_viewInRoomPhoto"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImageCredits_viewInRoomPhoto"
    }
  ],
  "type": "viewInRoomPhotos",
  "abstractKey": null
};

(node as any).hash = "4bb29f204270018359220b1e5ee399e4";

export default node;
